import { FC, memo, useContext, useEffect, useState } from "react";
import { DataContext, LikeButtonFlagContext } from "../../CreateContext";
import { MyModalHeader } from "./ModalHeader";
import {
  BsArrowRight,
  BsBellFill,
  BsFacebook,
  BsNewspaper,
} from "react-icons/bs";
import {
  AiFillInstagram,
  AiFillTwitterCircle,
  AiOutlineArrowRight,
  AiOutlineYoutube,
} from "react-icons/ai";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Icon,
  ModalBody,
  ModalContent,
  Progress,
  Spacer,
} from "@chakra-ui/react";
import { Body } from "./Body";
import { ButtonCard } from "../Card/ButtonCard";
import { motion, AnimatePresence } from "framer-motion";
import "../../../css/ImageGallery.scss";
import { Data } from "../../types/TypeData";
import { RiTwitterXFill } from "react-icons/ri";
import { Clock } from "../Gadget/Clock";
import { Apihost } from "../../DataGet";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

type Props = {
  id: number;
  onClose: () => void;
  isOpen: boolean;
  cursor: string | null;
  LikeCount: number;
  setLikeCount: React.Dispatch<React.SetStateAction<number>>;
};

const onCloseMethod: number = 1;
// 0: 何も触られないで30分後に現在表示中のコンテンツが終了したら、閉じる
// 1: 全てのコンテンツが一周したら、閉じる

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? -100 : 100,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? -100 : 100,
      opacity: 0,
    };
  },
};

export const ModalView: FC<Props> = memo((props) => {
  const { id, onClose, isOpen, cursor, LikeCount, setLikeCount } = props;
  const { modalContextData } = useContext(DataContext);
  const { LikeFlag, setLikeFlag } = useContext(LikeButtonFlagContext);
  const [modalData, setModalData] = useState(modalContextData);
  const apihost = Apihost();
  const _ = modalData.move.findIndex((data) => data.TOPIC_ID === id);
  useEffect(() => {
    if (LikeFlag && process.env.REACT_APP_OLD_API === "true") {
      fetch(`${apihost}/get-available-topics`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "DONT_PANIC",
        },
        body: JSON.stringify({ SORT_FOR_SIGNAGE: true }),
      })
        .then((response) => response.json())
        .then((res) => {
          // 同じTOPIC_IDが入ってきたらそのデータをdataに入れたくない
          const ids: Set<number> = new Set();
          const moveData: Data[] = [];
          const fixedData: Data[] = [];
          res.data.forEach((obj: Data) => {
            if (!ids.has(obj.TOPIC_ID)) {
              obj.TOPIC_BODY = obj.TOPIC_BODY?.replace(/\\n/g, "\n");
              // 旧APIの場合、dataの中のVOTESの中にWALL_LIKESが存在し、新APIの場合、VOTESが存在せず、WALL_LIKESがdataの中に直接存在している。
              // そのため、新旧APIのデータの構造を統一するために、旧APIのデータの場合、VOTESの中のWALL_LIKESをdataの中に移動させている。
              if (obj.VOTES) {
                obj.WALL_LIKES = obj.VOTES.WALL_LIKES;
              }
              ids.add(obj.TOPIC_ID);
              if (obj.CATEGORY_ID == 51) {
                fixedData.push(obj);
              } else {
                moveData.push(obj);
              }
            }
          });
          // 処理終了(TOPIC_IDが同じデータは消えています)
          // 優先配信が0枚の時、いいね数が最大のカードを固定する
          if (fixedData.length == 0) {
            let mostLikedData = moveData.reduce((maxLiked, currentData) => {
              if (currentData.WALL_LIKES > maxLiked.WALL_LIKES) {
                return currentData;
              }
              return maxLiked;
            }, moveData[0]);

            const indexToRemove = moveData.indexOf(mostLikedData);
            fixedData.push(mostLikedData);

            if (indexToRemove !== -1) {
              moveData.splice(indexToRemove, 1);
            }
          }

          //移動カードを順番に
          const moveSortData = moveData.sort((a, b) => a.TOPIC_ID - b.TOPIC_ID);
          setModalData({ fixed: fixedData, move: moveSortData });
          setLikeFlag(false);
        })
        .catch((error) => {
          console.log("データの取得に失敗しました", error);
        });
    }
  }, []);

  // _は、移動データにidが存在しなければ、-1になる
  const [fixedIndex, setFixedIndex] = useState(
    _ !== -1
      ? undefined
      : modalData.fixed.findIndex((data) => data.TOPIC_ID === id)
  );
  const [[index, direction], setIndex] = useState([_ !== -1 ? _ : 0, 0]);
  const miniViewData = [
    (((index - 1) % modalData.move.length) + modalData.move.length) %
      modalData.move.length,
    index,
    (index + 1) % modalData.move.length,
  ].map((index) => modalData.move[index]);
  const data =
    fixedIndex == undefined ? miniViewData[1] : modalData.fixed[fixedIndex];

  const [miniLeftLikeCount, setMiniLeftLikeCount] = useState(
    miniViewData[0].WALL_LIKES
  );
  const [miniCenterLikeCount, setMiniCenterLikeCount] = useState(
    miniViewData[1].WALL_LIKES
  );
  const [miniRightLikeCount, setMiniRightLikeCount] = useState(
    miniViewData[2].WALL_LIKES
  );
  const [fixed0LikeCount, setfixed0LikeCount] = useState(
    modalData.fixed && modalData.fixed[0] ? modalData.fixed[0].WALL_LIKES : 0
  );
  const [fixed1LikeCount, setfixed1LikeCount] = useState(
    modalData.fixed && modalData.fixed[1] ? modalData.fixed[1].WALL_LIKES : 0
  );
  const [fixed2LikeCount, setfixed2LikeCount] = useState(
    modalData.fixed && modalData.fixed[2] ? modalData.fixed[2].WALL_LIKES : 0
  );
  const [modalCanCloseFlag, setModalCanCloseFlag] = useState(false);

  // 元画面で、like押された時に更新しておく
  useEffect(() => {
    setLikeCount(LikeCount);
    setMiniLeftLikeCount(miniViewData[0].WALL_LIKES);
    setMiniRightLikeCount(miniViewData[2].WALL_LIKES);
    setMiniCenterLikeCount(miniViewData[1].WALL_LIKES);
    setfixed0LikeCount(modalData.fixed[0] ? modalData.fixed[0].WALL_LIKES : 0);
    setfixed1LikeCount(modalData.fixed[1] ? modalData.fixed[1].WALL_LIKES : 0);
    setfixed2LikeCount(modalData.fixed[2] ? modalData.fixed[2].WALL_LIKES : 0);
  }, [modalData]);

  useEffect(() => {
    if (LikeFlag) {
      if (fixedIndex == undefined) {
        if (miniCenterLikeCount > LikeCount) {
          setLikeCount(miniCenterLikeCount);
        } else if (miniCenterLikeCount < LikeCount) {
          setMiniCenterLikeCount(LikeCount);
        }
      }
    }
  }, [miniCenterLikeCount, LikeCount]);

  useEffect(() => {
    if (LikeFlag) {
      if (fixedIndex == 0) {
        if (fixed0LikeCount > LikeCount) {
          setLikeCount(fixed0LikeCount);
        } else if (fixed0LikeCount < LikeCount) {
          setfixed0LikeCount(LikeCount);
        }
      } else if (fixedIndex == 1) {
        if (fixed1LikeCount > LikeCount) {
          setLikeCount(fixed1LikeCount);
        } else if (fixed1LikeCount < LikeCount) {
          setfixed1LikeCount(LikeCount);
        }
      } else if (fixedIndex == 2) {
        if (fixed2LikeCount > LikeCount) {
          setLikeCount(fixed2LikeCount);
        } else if (fixed2LikeCount < LikeCount) {
          setfixed2LikeCount(LikeCount);
        }
      }
    }
  }, [fixed0LikeCount, fixed1LikeCount, fixed2LikeCount, LikeCount]);

  let ModalIcon = BsFacebook;
  let TypeMenu: string = "";

  const [lastClickTime, setLastClickTime] = useState(0);
  const [paginateTime, setPaginateTime] = useState(0);
  // クリックされた時
  const paginate = (newDirection: number) => {
    const now = Date.now();
    const timeSinceLastClick = now - lastClickTime;
    if (data.CATEGORY_ID == 4) {
      if (timeSinceLastClick < 1500) {
        // 連打されると、Youtubeの挙動がおかしくなる
        return;
      }
    } else {
      if (timeSinceLastClick < 700) {
        return;
      }
    }
    setLastClickTime(now);

    // onCloseMethod == 1 の場合
    if (onCloseMethod == 1) {
      setPaginateTime(paginateTime + 1);
      if (paginateTime > modalData.move.length) {
        setModalCanCloseFlag(true);
        setPaginateTime(0);
      }
    }
    if (index + newDirection == -1) {
      setIndex([modalData.move.length - 1, newDirection]);
      setFixedIndex(undefined);
      const newMiniViewData = [
        (((modalData.move.length - 2) % modalData.move.length) +
          modalData.move.length) %
          modalData.move.length,
        modalData.move.length - 1,
        modalData.move.length % modalData.move.length,
      ].map((index) => modalData.move[index]);
      setLikeCount(miniLeftLikeCount);
      setMiniLeftLikeCount(newMiniViewData[0].WALL_LIKES);
      setMiniRightLikeCount(LikeCount);
      setMiniCenterLikeCount(miniLeftLikeCount);
    } else {
      setIndex([(index + newDirection) % modalData.move.length, newDirection]);
      setFixedIndex(undefined);
      const newMiniViewData = [
        (((((index + newDirection) % modalData.move.length) - 1) %
          modalData.move.length) +
          modalData.move.length) %
          modalData.move.length,
        (index + newDirection) % modalData.move.length,
        (((index + newDirection) % modalData.move.length) + 1) %
          modalData.move.length,
      ].map((index) => modalData.move[index]);
      if (newDirection < 0) {
        setLikeCount(miniLeftLikeCount);
        setMiniLeftLikeCount(newMiniViewData[0].WALL_LIKES);
        if (fixedIndex) {
          setMiniRightLikeCount(miniCenterLikeCount);
        } else {
          setMiniRightLikeCount(LikeCount);
        }
        setMiniCenterLikeCount(miniLeftLikeCount);
      } else if (newDirection > 0) {
        setLikeCount(miniRightLikeCount);
        if (fixedIndex) {
          setMiniLeftLikeCount(LikeCount);
        } else {
          setMiniLeftLikeCount(miniCenterLikeCount);
        }
        setMiniRightLikeCount(newMiniViewData[2].WALL_LIKES);
        setMiniCenterLikeCount(miniRightLikeCount);
      } else {
        setLikeCount(miniCenterLikeCount);
      }
    }
  };

  // 固定カードの枚数によってレイアウト変更
  let fixedCardWidth: { left: string; right: string } = {
    left: "100%",
    right: "100%",
  };
  if (window.innerWidth > window.innerHeight) {
    if (modalData.fixed.length === 1) {
      fixedCardWidth.left = "20%";
      fixedCardWidth.right = "80%";
    } else if (modalData.fixed.length === 2) {
      fixedCardWidth.left = "30%";
      fixedCardWidth.right = "70%";
    } else {
      fixedCardWidth.left = "44%";
      fixedCardWidth.right = "56%";
    }
  }

  if (data.CATEGORY_ID == 2) {
    TypeMenu = "twitter";
    ModalIcon = RiTwitterXFill;
  } else if (data.CATEGORY_ID == 1) {
    TypeMenu = "user_news";
    ModalIcon = BsFacebook;
  } else if (data.CATEGORY_ID == 4) {
    TypeMenu = "youtube";
    ModalIcon = AiOutlineYoutube;
  } else if (data.CATEGORY_ID == 3) {
    TypeMenu = "instagram";
    ModalIcon = AiFillInstagram;
  } else {
    TypeMenu = "university_news";
    ModalIcon = BsNewspaper;
  }
  let miniViewTypeMenu: string[] = [];
  miniViewData.map((data) => {
    if (data.CATEGORY_ID == 2) {
      miniViewTypeMenu.push("twitter");
    } else if (data.CATEGORY_ID == 1) {
      miniViewTypeMenu.push("user_news");
    } else if (data.CATEGORY_ID == 4) {
      miniViewTypeMenu.push("youtube");
    } else if (data.CATEGORY_ID == 3) {
      miniViewTypeMenu.push("instagram");
    } else {
      miniViewTypeMenu.push("university_news");
    }
  });

  let fixedTypeMenu: string[] = [];
  modalData.fixed.map((data) => {
    if (data.CATEGORY_ID == 2) {
      fixedTypeMenu.push("twitter");
    } else if (data.CATEGORY_ID == 1) {
      fixedTypeMenu.push("user_news");
    } else if (data.CATEGORY_ID == 4) {
      fixedTypeMenu.push("youtube");
    } else if (data.CATEGORY_ID == 3) {
      fixedTypeMenu.push("instagram");
    } else {
      fixedTypeMenu.push("university_news");
    }
  });
  // 放置された時の動き
  // onCloseMethod = 0の場合
  let timerId: NodeJS.Timer | undefined;
  useEffect(() => {
    if (onCloseMethod == 0) {
      const TimerStart = () => {
        timerId = setTimeout(() => {
          setModalCanCloseFlag(true);
          clearTimeout(timerId);
        }, 30 * 60 * 1000); //30分何も画面を触らなければ、詳細画面が閉じる
      };

      const handleTouch = () => {
        setModalCanCloseFlag(false);
        clearTimeout(timerId); // タッチイベントが発生したらタイマーをクリア
        TimerStart();
      };
      document.addEventListener("mousemove", handleTouch);
      document.addEventListener("touchstart", handleTouch);

      isOpen == true ? TimerStart() : clearTimeout(timerId);
    }
  }, [isOpen]);

  return (
    <ModalContent
      borderRadius="16px"
      bg="transparent"
      backdropFilter="blur(10px)"
      gap={0}
      pb={`${HeightCalculation(20, 20)}px`}
      cursor={cursor == "true" ? "true" : "none"}
    >
      <Clock length={3} />
      <Box
        marginTop={`${HeightCalculation(10, 200)}px`}
        marginLeft={`${WidthCalculation(54, 32)}px`}
        minHeight={`${window.innerHeight * 0.92}px`}
        width={`${window.innerWidth * 0.94}px`}
      >
        <motion.div
          key={data.TOPIC_ID}
          style={{
            marginBottom: `${HeightCalculation(30, 100)}px`,
            touchAction: "pan-y",
          }}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 100, damping: 20 },
            opacity: { duration: 0.4 },
          }}
        >
          <MyModalHeader
            TopicAuthorName={data.TOPIC_AUTHOR_NAME}
            TypeMenu={TypeMenu}
            ModalIcon={ModalIcon}
            onClose={onClose}
          />
          <ModalBody padding={0}>
            <Body
              ModalLayout={1}
              Title={data.TOPIC_TITLE}
              Medias={data.MEDIAS}
              WallLikes={
                process.env.REACT_APP_OLD_API === "true"
                  ? data.VOTES.WALL_LIKES
                  : data.WALL_LIKES
              }
              TopicBody={data.TOPIC_BODY}
              TopicAuthorName={data.TOPIC_AUTHOR_NAME}
              TopicID={data.TOPIC_ID}
              TypeMenu={TypeMenu}
              onClose={onClose}
              isOpen={isOpen}
              LikeCount={LikeCount}
              setLikeCount={setLikeCount}
              paginate={paginate}
              index={index}
              modalCanCloseFlag={modalCanCloseFlag}
            />
          </ModalBody>
        </motion.div>
        <Box
          display={
            window.innerHeight > window.innerWidth ? "flexColumn" : "flex"
          }
          w="100%"
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            w={`${fixedCardWidth.right}`}
            pl={`${WidthCalculation(30, 0)}px`}
          >
            <div className="image-gallery-container">
              <Box w="85%">
                <Flex
                  h={`${window.innerHeight * 0.226}px`}
                  w="100%"
                  gap={3}
                  overflow="hidden"
                  justifyContent="center"
                  alignItems="center"
                >
                  <AnimatePresence mode="popLayout" initial={false}>
                    {miniViewData.map((data, miniViewDataIndex) => {
                      const stereoVariants = {
                        enter: (direction: number) => {
                          return {
                            scale: 0.2,
                            x: direction < 0 ? 100 : -100,
                            opacity: 0,
                          };
                        },
                        center: () => {
                          return {
                            ...getCenterXPosition(),
                          };
                        },
                        exit: (direction: number) => {
                          return {
                            scale: 0,
                            x: direction < 0 ? 100 : -100,
                            opacity: 0,
                          };
                        },
                      };
                      const DistanceAway =
                        window.innerWidth < window.innerHeight
                          ? window.innerWidth * 0.64
                          : modalData.fixed.length === 1
                          ? window.innerWidth * 0.43
                          : modalData.fixed.length === 2
                          ? window.innerWidth * 0.4
                          : window.innerWidth * 0.345;
                      const ScaleRatio =
                        window.innerWidth > window.innerHeight ? 0.85 : 0.8;
                      const getCenterXPosition = () => {
                        switch (miniViewDataIndex) {
                          case 0:
                            return {
                              x: DistanceAway,
                              zIndex: 1,
                              scale: ScaleRatio,
                              opacity: 0.8,
                            };
                          case 2:
                            return {
                              x: -1 * DistanceAway,
                              zIndex: 1,
                              scale: ScaleRatio,
                              opacity: 0.8,
                            };
                          case 1:
                            return {
                              x: 0,
                              zIndex: 3,
                              scale: 1,
                              opacity: 1,
                            };
                          default:
                            return {
                              x: 0,
                              zIndex: 3,
                            };
                        }
                      };

                      return (
                        <motion.div
                          key={data.TOPIC_ID}
                          id={data.TOPIC_TITLE}
                          style={{
                            width: "auto",
                            height: "auto",
                          }}
                          custom={{ direction, miniViewDataIndex }}
                          layout
                          variants={stereoVariants}
                          initial="enter"
                          animate="center"
                          exit="exit"
                          transition={{ duration: 0.4 }}
                          onClick={() => paginate(miniViewDataIndex - 1)}
                        >
                          <ButtonCard
                            key={miniViewDataIndex}
                            Title={data.TOPIC_TITLE}
                            Medias={data.MEDIAS}
                            WallLikes={
                              process.env.REACT_APP_OLD_API === "true"
                                ? data.VOTES.WALL_LIKES
                                : data.WALL_LIKES
                            }
                            TopicAuthorName={data.TOPIC_AUTHOR_NAME}
                            TopicBody={data.TOPIC_BODY}
                            TypeMenu={miniViewTypeMenu[miniViewDataIndex]}
                            TopicID={data.TOPIC_ID}
                            modalFlag={true}
                            LikeCount={
                              miniViewDataIndex === 0
                                ? miniLeftLikeCount
                                : miniViewDataIndex === 1
                                ? miniCenterLikeCount
                                : miniRightLikeCount
                            }
                            setLikeCount={
                              miniViewDataIndex === 0
                                ? setMiniLeftLikeCount
                                : miniViewDataIndex === 1
                                ? setMiniCenterLikeCount
                                : setMiniRightLikeCount
                            }
                            ModalLayout={1}
                          />
                        </motion.div>
                      );
                    })}
                  </AnimatePresence>
                </Flex>
              </Box>
              <div className="modal-next" onClick={() => paginate(-1)}>
                <Icon as={AiOutlineArrowRight} />
              </div>
              <div className="modal-prev" onClick={() => paginate(1)}>
                <Icon as={AiOutlineArrowRight} />
              </div>
            </div>
          </Box>
          <Flex
            w={`${fixedCardWidth.left}`}
            gap={4}
            style={{ order: -1 }}
            justifyContent="center"
            alignItems="center"
          >
            {modalData.fixed.map((data, _) => (
              <Flex key={_} justifyContent="center" alignItems="center">
                <Box
                  onClick={() => {
                    setFixedIndex(_);
                    setLikeCount(
                      _ === 0
                        ? fixed0LikeCount
                        : _ === 1
                        ? fixed1LikeCount
                        : fixed2LikeCount
                    );
                  }}
                >
                  <ButtonCard
                    Title={data.TOPIC_TITLE}
                    Medias={data.MEDIAS}
                    WallLikes={
                      process.env.REACT_APP_OLD_API === "true"
                        ? data.VOTES.WALL_LIKES
                        : data.WALL_LIKES
                    }
                    TopicAuthorName={data.TOPIC_AUTHOR_NAME}
                    TopicBody={data.TOPIC_BODY}
                    TypeMenu={fixedTypeMenu[_]}
                    TopicID={data.TOPIC_ID}
                    length={modalData.fixed.length}
                    modalFlag={true}
                    LikeCount={
                      _ === 0
                        ? fixed0LikeCount
                        : _ === 1
                        ? fixed1LikeCount
                        : fixed2LikeCount
                    }
                    setLikeCount={
                      _ === 0
                        ? setfixed0LikeCount
                        : _ === 1
                        ? setfixed1LikeCount
                        : setfixed2LikeCount
                    }
                    ModalLayout={1}
                  />
                </Box>
              </Flex>
            ))}
            {window.innerWidth > window.innerHeight && <Spacer />}
          </Flex>
        </Box>
      </Box>
    </ModalContent>
  );
});
